import { Box } from "@chakra-ui/react";
import Navbar from "../Components/Navbar";
import Images from "../Components/Images.jsx";
import Footer from "../Components/Footer";

function LandingLayout({ children, ...otherProps }) {
  return (
    <Box {...otherProps} backgroundImage={`url(${Images.PatternBackground})`}>
      <Navbar />
      {children}
      <Footer />
    </Box>
  );
}

export default LandingLayout;
